import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      strokeWidth={1.5}
      d="m15.225 4.67-.014-.013-.016-.016c-.257-.257-.5-.5-.726-.673-.252-.193-.57-.366-.975-.366-.406 0-.723.173-.976.366-.226.172-.469.416-.726.673l-.03.03-6.11 6.11-.034.034c-.13.13-.284.283-.393.476-.11.192-.162.403-.206.582l-.011.046-.564 2.254-.007.029a3 3 0 0 0-.087.436.96.96 0 0 0 .261.792l.53-.529-.53.53c.282.28.628.277.793.261.145-.014.31-.056.436-.087l.029-.007 2.254-.564.046-.011c.179-.045.39-.097.582-.206l-.37-.652.37.652c.193-.109.346-.263.476-.393l.033-.034 6.11-6.11.031-.03c.257-.258.5-.5.673-.727.192-.252.366-.57.366-.975 0-.406-.174-.723-.366-.975a8 8 0 0 0-.673-.726l-.03-.03zm-3.855.604 3.398 3.397"
    />
  </svg>
);
export default SvgEdit;
